import React, { useState } from 'react';
import {
    Send,
    Search,
    MessageCircle,
    Circle,
    ChevronRight,
} from 'lucide-react';
import SidebarAdmin from './superdashboard/SideBarAdmin';
import MobileNavigationAdmin from './superdashboard/MobileNavigationAdmin';
import DashboardHeaderAdmin from './superdashboard/DashboardHeaderAdmin';
import AdminMenu from '../components/AdminMenu';

const Messagerie = () => {
    const [isSidebarOpen, setIsSidebarOpen] = useState(true);
    const [selectedChat, setSelectedChat] = useState(null);
    const [message, setMessage] = useState('');
    const [filterText, setFilterText] = useState('');

    // Example data
    const conversations = [
        {
            id: 1,
            user: 'Amadou Ibrahim',
            lastMessage: 'Je voudrais des informations sur...',
            timestamp: '10:30',
            unread: 2,
            messages: [
                { id: 1, sender: 'user', content: 'Bonjour, je voudrais des informations sur les visas', time: '10:25' },
                { id: 2, sender: 'admin', content: 'Bonjour, bien sûr ! Quel type de visa vous intéresse ?', time: '10:28' },
                { id: 3, sender: 'user', content: 'Je voudrais des informations sur le visa touristique', time: '10:30' }
            ]
        },
        {
            id: 2,
            user: 'Mariama Diallo',
            lastMessage: 'Merci pour votre aide',
            timestamp: '09:15',
            unread: 0,
            messages: [
                { id: 1, sender: 'user', content: 'Merci pour votre aide', time: '09:15' }
            ]
        }
    ];

    const handleSendMessage = (e) => {
        e.preventDefault();
        if (!message.trim()) return;

        // Add message logic here
        console.log('Message sent:', message);
        setMessage('');
    };

    const filteredConversations = conversations.filter(conv =>
        conv.user.toLowerCase().includes(filterText.toLowerCase())
    );

    return (
        <div className="flex min-h-screen bg-[#F4F8E9]">
            <SidebarAdmin
                isOpen={isSidebarOpen}
                menuItems={AdminMenu}
                onClose={() => setIsSidebarOpen(false)}
            />

            <div className="flex-1">
                <DashboardHeaderAdmin
                    isSidebarOpen={isSidebarOpen}
                    setIsSidebarOpen={setIsSidebarOpen}
                />

                <main className="max-w-7xl mx-auto px-4 sm:px-6 py-4 sm:py-8 pb-20 lg:pb-8">
                    <div className="bg-white rounded-lg shadow min-h-[600px] flex">
                        {/* Conversations List */}
                        <div className="w-1/3 border-r">
                            <div className="p-4 border-b">
                                <h2 className="text-xl font-bold text-[#437011] mb-4">Messages</h2>
                                <div className="relative">
                                    <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
                                    <input
                                        type="text"
                                        placeholder="Rechercher une conversation..."
                                        className="w-full pl-10 pr-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#437011]"
                                        value={filterText}
                                        onChange={(e) => setFilterText(e.target.value)}
                                    />
                                </div>
                            </div>
                            <div className="overflow-y-auto h-[500px]">
                                {filteredConversations.map((conv) => (
                                    <div
                                        key={conv.id}
                                        className={`p-4 border-b hover:bg-gray-50 cursor-pointer ${
                                            selectedChat?.id === conv.id ? 'bg-gray-50' : ''
                                        }`}
                                        onClick={() => setSelectedChat(conv)}
                                    >
                                        <div className="flex justify-between items-start mb-1">
                                            <h3 className="font-medium">{conv.user}</h3>
                                            <span className="text-sm text-gray-500">{conv.timestamp}</span>
                                        </div>
                                        <div className="flex justify-between items-center">
                                            <p className="text-sm text-gray-600 truncate">{conv.lastMessage}</p>
                                            {conv.unread > 0 && (
                                                <span className="bg-[#437011] text-white text-xs rounded-full px-2 py-1">
                                                    {conv.unread}
                                                </span>
                                            )}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/* Chat Area */}
                        <div className="flex-1 flex flex-col">
                            {selectedChat ? (
                                <>
                                    {/* Chat Header */}
                                    <div className="p-4 border-b flex justify-between items-center">
                                        <div>
                                            <h3 className="font-medium">{selectedChat.user}</h3>
                                            <p className="text-sm text-gray-500">En ligne</p>
                                        </div>
                                    </div>

                                    {/* Messages */}
                                    <div className="flex-1 overflow-y-auto p-4 space-y-4">
                                        {selectedChat.messages.map((msg) => (
                                            <div
                                                key={msg.id}
                                                className={`flex ${
                                                    msg.sender === 'admin' ? 'justify-end' : 'justify-start'
                                                }`}
                                            >
                                                <div
                                                    className={`max-w-[70%] rounded-lg p-3 ${
                                                        msg.sender === 'admin'
                                                            ? 'bg-[#437011] text-white'
                                                            : 'bg-gray-100'
                                                    }`}
                                                >
                                                    <p>{msg.content}</p>
                                                    <span className="text-xs mt-1 block opacity-70">
                                                        {msg.time}
                                                    </span>
                                                </div>
                                            </div>
                                        ))}
                                    </div>

                                    {/* Message Input */}
                                    <form onSubmit={handleSendMessage} className="p-4 border-t">
                                        <div className="flex gap-2">
                                            <input
                                                type="text"
                                                value={message}
                                                onChange={(e) => setMessage(e.target.value)}
                                                placeholder="Tapez votre message..."
                                                className="flex-1 px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#437011]"
                                            />
                                            <button
                                                type="submit"
                                                className="px-4 py-2 bg-[#437011] text-white rounded-lg hover:bg-[#2F5000] transition-colors"
                                            >
                                                <Send className="w-5 h-5" />
                                            </button>
                                        </div>
                                    </form>
                                </>
                            ) : (
                                <div className="flex-1 flex items-center justify-center text-gray-500">
                                    <div className="text-center">
                                        <MessageCircle className="w-12 h-12 mx-auto mb-2" />
                                        <p>Sélectionnez une conversation pour commencer</p>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </main>

                <MobileNavigationAdmin menuItems={AdminMenu} />
            </div>
        </div>
    );
};

export default Messagerie;